import {ThemedText, ThemedView} from "@app/theme";
import StepCompleteIcon from "../../../../assets/Icons/StepCompleteIcon";
import React from "react";
import {FlatList, Platform} from "react-native";
import {KYC_STEPPER_STATUSES} from "@screens/KYCStepper/enums/enums";

interface KYCVerticalStepperProps {
    stepperData: any
}

const renderIndividualItem = (item: any, index: number, stepperData: any) => {
    const statusNotStarted = item.status === KYC_STEPPER_STATUSES.NOT_STARTED
    const statusInProgress = item.status === KYC_STEPPER_STATUSES.IN_PROGRESS
    const statusCompleted = item.status === KYC_STEPPER_STATUSES.COMPLETED
    return (
        <ThemedView>
            <ThemedView flexDirection={"row"} alignItems={"flex-start"}
                        alignContent={"flex-start"}>
                <ThemedView alignItems={"center"} alignSelf={"center"}>
                    {statusCompleted?
                        <StepCompleteIcon/> :
                        <ThemedView width={36} height={36} backgroundColor={statusNotStarted ? "border-primary" : "bg-fill-emphasis-primary-1"} alignItems={"center"} justifyContent={"center"} borderRadius={"xl"}>
                            <ThemedView width={24} height={24} backgroundColor={statusNotStarted ? "icon-secondary" : "text-action-primary"}
                                        alignItems={"center"} borderRadius={"xl"} justifyContent={"center"}
                                        alignSelf={"center"}>
                                <ThemedText color={"white"} variant={ Platform.OS === 'web' ? "b2s" : 'b4s'}>
                                    {index + 1}
                                </ThemedText>
                            </ThemedView>
                        </ThemedView>
                    }
                    {index !== stepperData.length - 1 && (
                        <ThemedView
                            width={1}
                            backgroundColor={"icon-secondary"}
                            borderStyle={"solid"}
                            borderColor={"border-primary"}
                            borderWidth={1}
                            height={25}
                            marginVertical={"xs"}
                            alignSelf={"center"}
                        />
                    )}
                </ThemedView>
                <ThemedView ml={"md"}>
                    <ThemedText variant={"b3s"} color={statusInProgress ? "text-primary" : "text-disabled"}>
                        {item.verticalDisplayName}
                    </ThemedText>
                    <ThemedText variant={"b4r"} color={statusInProgress ? "text-secondary": "text-disabled"}>
                        {item.verticalDescription}
                    </ThemedText>
                </ThemedView>
            </ThemedView>
        </ThemedView>
    )
}


const KYCVerticalStepper: React.FC<KYCVerticalStepperProps> =  ({stepperData}) => {
    return (
        <ThemedView mt={"4xl"}>
          <FlatList data={stepperData} renderItem={({item, index}) => renderIndividualItem(item, index, stepperData)} />
        </ThemedView>
    )

}
export default KYCVerticalStepper;